<p-inputSwitch
  [inputId]="inputId"
  [ngModel]="value"
  [disabled]="disabled"
  (ngModelChange)="onValueChange($event)"
  (onBlur)="onBlur()">
</p-inputSwitch>
